import '../../assets/css/profile.css';

import { Component, createRef } from 'react';
import { connect } from "react-redux";
import { fetchingUser, fetchingUserSuccess } from "../../redux/actions";
import { withRouter } from "react-router-dom";
import api from "../../lib/api";
import {
	getUrl,
	handleClickOutside,
	preventDefault,
	readURL,
	setClassNameCondition,
	showNotification,
	navigateTo,
	goBack
} from "../../lib/helper";
import $ from 'jquery';

import QRCode from 'qrcode';
import { withTranslation } from 'react-i18next';

class Profile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...props.memberReducer,
			current_password: '',
			new_password: '',
			is_show_modal_avatar: false,
			is_show_modal_auth: false,
			is_show_modal_disable_two_fa: false,
			upload_avatar: {},
			secret: '',
			qr_code: '',

			auth_password: '',
			auth_email_code: '',
			auth_two_fa_code: ''
		};
		this.inputPicture = null;

		this.refList = {
			is_show_modal_avatar: createRef(),
			is_show_modal_auth: createRef()
		};
	}

	onChangeInput = (type) => (e) => {
		this.setState({ [type]: e.target.value });
	}

	onSubmitInfo = () => {
		let { first_name, last_name, withdrawal_password } = this.state;
		api.putChangeProfile({ first_name, last_name, withdrawal_password })
			.then(({ data, success, message }) => {
				showNotification({ message, type: success ? 'success' : 'danger' });
				this.props.fetchingUserSuccess(data);
			});
	}

	onSubmitPassword = () => {
		let { current_password, new_password } = this.state;
		api.putChangePassword(current_password, new_password)
			.then(({ data, success, message }) => {
				showNotification({ message, type: success ? 'success' : 'danger' });
			});
	}

	onClickChangeAvatar = (is_show) => () => {
		this.setState({ is_show_modal_avatar: is_show });
	}

	onBrowsePicture = () => {
		this.inputPicture?.click();
	}

	onChangeFileInput = (e) => {
		readURL(e.target.files).then(result => {
			let { data, size } = result || {};
			this.setState({ upload_avatar: { data, size } });
		});
	}

	onClickSubmitAvatar = () => {
		if (this.inputPicture?.files && this.inputPicture.files.length) {
			api.postChangeAvatar(this.inputPicture.files[0])
				.then(({ data, message, success }) => {
					showNotification({ message, type: success ? 'success' : 'danger' });
					if (success) {
						this.props.fetchingUserSuccess(data);
						this.setState({ is_show_modal_avatar: false, ...data });
					}
				});
		}
	}

	onShowDisableTwoFa = (is_show) => () => {
		if (is_show) {
			$('body').addClass('modal-open');
		} else {
			$('body').removeClass('modal-open');
			this.setState({ is_two_fa: true });
		}
		this.setState({ is_show_modal_disable_two_fa: is_show })
	}

	onShowAuthModal = (is_show) => () => {
		if (is_show) {
			$('body').addClass('modal-open');
			api.getTwoFaKey().then(({ data, success }) => {
				if (success && data) {
					let { secret, auth_string } = data;
					QRCode.toString(auth_string).then(qrCode => {
						this.setState({ secret: secret, qr_code: qrCode });
					});
				}
			});
		} else {
			$('body').removeClass('modal-open');
			this.setState({ is_two_fa: false });
		}
		this.setState({ is_show_modal_auth: is_show })
	}

	onChangeTwoFa = () => {
		if (!this.props.memberReducer.is_two_fa && !this.state.is_two_fa) {
			this.onShowAuthModal(true)();
		}
		if (this.props.memberReducer.is_two_fa && this.state.is_two_fa) {
			this.onShowDisableTwoFa(true)();
		}
		this.setState({ is_two_fa: !this.state.is_two_fa });
	}

	onClickPaste = (type) => (e) => {
		navigator.clipboard.readText()
			.then(text => this.setState({ [type]: text }))
			.catch(e => console.log(e));
	}

	onCopySecret = (e) => {
		e && e.preventDefault();
		navigator.clipboard.writeText(this.state.secret)
			.then(() => {
				showNotification({ type: 'success', message: 'Đã sao chép vào bộ nhớ' });
			})
			.catch(e => {
				showNotification({ type: 'danger', message: e.message });
			})
	}

	onSendOTPEmail = () => {
		api.postOTPEmail().then(({ success, message }) => {
			showNotification({ type: success ? 'success' : 'danger', message });
		})
	}

	onDisableTwoFa = () => {
		let { auth_password, auth_email_code, auth_two_fa_code } = this.state;
		api.postDisableTwoFa({ auth_password, auth_email_code, auth_two_fa_code })
			.then(({ message, success, data }) => {
				showNotification({ type: success ? 'success' : 'danger', message });
				if (success && data) {
					this.onShowDisableTwoFa(false)();
					this.props.fetchingUserSuccess(data);
					this.setState({ ...data });
				}
			});
	}

	onEnableTwoFa = () => {
		let { auth_password, auth_email_code, auth_two_fa_code, secret } = this.state;
		api.postEnableTwoFa({ auth_password, auth_email_code, auth_two_fa_code, secret })
			.then(({ success, message, data }) => {
				showNotification({ type: success ? 'success' : 'danger', message });
				if (success && data) {
					this.onShowAuthModal(false)();
					this.props.fetchingUserSuccess(data);
					this.setState({ ...data });
				}
			})
	}

	componentDidMount() {
		if (!this.props.memberReducer?.login_token) {
			return this.props.history.push('/login');
		}
	}

	render() {
		let { email, username, first_name, last_name, current_password, new_password, is_show_modal_avatar, is_show_modal_disable_two_fa, avatar, upload_avatar, phone, secret, qr_code, is_show_modal_auth, auth_password, auth_email_code, auth_two_fa_code, withdrawal_password } = this.state;
		let { first_name: first_name_old, last_name: last_name_old, user_mode, verified_point, is_verify, withdrawal_password: withdrawal_password_old } = this.props.memberReducer;
		let _avatar = upload_avatar.data || avatar;
		let is_button_enable = auth_password.length && auth_email_code.length === 6 && auth_two_fa_code.length === 6;
		let { bot_username } = this.props.appReducer;
		const { t } = this.props;
		return (
			<div data-v-b0e45e8c="" id="mainContent">
				<div data-v-b0e45e8c="" className="boxContent">
					<div data-v-9792f17c="" data-v-b0e45e8c="">
						<div data-v-9792f17c="" className="profileContent">
							<div data-v-9792f17c="" className="container">
								<button data-v-36ad2db4="" class="btn btn-primary bgSecondaryBtn3 mb-3" onClick={this.props.history.goBack}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> {t('common.goback')}</button>
								<div data-v-9792f17c="" className="panel panel--personal">
									<div data-v-9792f17c="" className="panel-header">

										<h3 data-v-9792f17c="" className="panel-header-title">
											{t('profile.title')}
										</h3>
									</div>
									<div data-v-9792f17c="" className="panel-body">
										<div data-v-9792f17c="" className="uploadAvatar mb-3">
											<div data-v-9792f17c="" className="d-flex align-items-center">
												<div data-v-de2bfc3e="" data-v-9792f17c="">
													<div data-v-de2bfc3e="" onClick={this.onClickChangeAvatar(true)} className="user-avatar" style={{ backgroundImage: avatar ? `url(${avatar})` : null }}>
														<div data-v-de2bfc3e="" className="overlay" />
														{user_mode === 'unlimited' && <span className='avatar-vip'>vip</span>}
													</div>
													<div data-v-de2bfc3e="" data-backdrop="static" tabIndex="-1"
														role="dialog" aria-hidden={!is_show_modal_avatar}
														style={{ display: is_show_modal_avatar ? 'block' : 'none' }}
														className={'modal fade ' + (is_show_modal_avatar ? 'show' : '')}>
														<div data-v-de2bfc3e=""
															className="modal-dialog simple modal-sm modal-upload-img">
															<div data-v-de2bfc3e="" className="modal-content p-3">
																<div data-v-de2bfc3e="" className="modal-header d-flex justify-content-between align-items-center">
																	<h3 data-v-de2bfc3e="" className="modalTitle">{t('profile.upload_images_from_computer')}</h3>
																	<button data-v-de2bfc3e="" type="button"
																		onClick={this.onClickChangeAvatar(false)}
																		aria-label="Close" className="btnclose">
																		<img alt=''
																			data-v-de2bfc3e=""
																			src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICA8ZyBpZD0iR3JvdXBfMTExMzQiIGRhdGEtbmFtZT0iR3JvdXAgMTExMzQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjY4LjM0NSAtMjguMzQ1KSI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzIwMSIgZGF0YS1uYW1lPSJFbGxpcHNlIDIwMSIgY3g9IjEwLjUiIGN5PSIxMC41IiByPSIxMC41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjY4LjM0NSAyOC4zNDUpIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwLjE5Ii8+CiAgICA8ZyBpZD0iZS1yZW1vdmUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyNzQuNjI0IDM0LjYyNCkiPgogICAgICA8cGF0aCBpZD0iUGF0aF8xMzc4NCIgZGF0YS1uYW1lPSJQYXRoIDEzNzg0IiBkPSJNOS4wNDcsMS4xNzZhLjU2OC41NjgsMCwwLDAtLjgyMiwwTDUuMTExLDQuMjg5LDIsMS4xNzZhLjU2OC41NjgsMCwwLDAtLjgyMiwwLC41NjguNTY4LDAsMCwwLDAsLjgyMkw0LjI4OSw1LjExMSwxLjE3Niw4LjIyNGEuNTY4LjU2OCwwLDAsMCwwLC44MjIuNTMzLjUzMywwLDAsMCwuNDExLjE3NkEuNTMzLjUzMywwLDAsMCwyLDkuMDQ3TDUuMTExLDUuOTM0LDguMjI0LDkuMDQ3YS41NjguNTY4LDAsMCwwLC44MjIsMCwuNTY4LjU2OCwwLDAsMCwwLS44MjJMNS45MzQsNS4xMTEsOS4wNDcsMkEuNTY4LjU2OCwwLDAsMCw5LjA0NywxLjE3NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIC0xKSIgZmlsbD0iI2ZmZiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==" />
																	</button>
																</div>
																<div data-v-de2bfc3e="" className="modal-body">
																	<div data-v-de2bfc3e="" className="upload-example">
																		<div data-v-de2bfc3e="">
																			<div data-v-de2bfc3e=""
																				onClick={this.onBrowsePicture}
																				className="avatarEmpty text-center">
																				<input data-v-de2bfc3e="" type="file"
																					onChange={this.onChangeFileInput}
																					ref={input => this.inputPicture = input}
																					accept=".jpg,.jpeg,.png"
																					className="fileUpload" />
																				<div style={{ display: _avatar ? 'none' : 'initial', paddingTop: '45px' }}>
																					<svg data-v-de2bfc3e=""
																						xmlns="http://www.w3.org/2000/svg"
																						width="89.156" height="95.1"
																						viewBox="0 0 89.156 95.1">
																						<g data-v-de2bfc3e=""
																							id="upload-and-send"
																							transform="translate(0 0)"
																							opacity="0.3">
																							<path data-v-de2bfc3e=""
																								id="Path_34910"
																								data-name="Path 34910"
																								d="M25.038,1.016a2.972,2.972,0,0,1,4.476,0l20.8,23.775a2.972,2.972,0,0,1-2.241,4.927H36.188V68.353a2.972,2.972,0,0,1-2.972,2.972H21.329a2.972,2.972,0,0,1-2.972-2.972V29.719H6.469a2.972,2.972,0,0,1-2.235-4.927Z"
																								transform="translate(17.306 0)"
																								fill="#fefefe" />
																							<path data-v-de2bfc3e=""
																								id="Path_34911"
																								data-name="Path 34911"
																								d="M77.269,11V28.831H11.888V11H0V34.775a5.944,5.944,0,0,0,5.944,5.944H83.213a5.944,5.944,0,0,0,5.944-5.944V11Z"
																								transform="translate(0 54.381)"
																								fill="#fefefe" />
																						</g>
																					</svg>
																					<p data-v-de2bfc3e="">{t('profile.click_here_to_upload_photos')}</p>
																				</div>
																				<img className='img-avatar'
																					style={{ display: !_avatar ? 'none' : 'initial' }}
																					src={_avatar} alt="" />
																			</div>
																			<div data-v-de2bfc3e="" className="imgInfo">
																				{upload_avatar.size > 0 && <p data-v-de2bfc3e=""><span
																					data-v-de2bfc3e=""
																					className="fileSize">{t('profile.size')}: </span>
																					<span data-v-de2bfc3e="" className="size colorGreen">
																						<b data-v-de2bfc3e="">{(upload_avatar.size / 1048576).toFixed(2)} MB</b>
																					</span>
																				</p>}
																				<p data-v-de2bfc3e="">{t('profile.photo_uploads_need_to_be_under_5mb')}</p></div>
																			<div data-v-de2bfc3e=""
																				className="d-flex justify-content-center align-items-center submit">
																				<button type='button' data-v-de2bfc3e=""
																					disabled={!upload_avatar.size}
																					onClick={this.onClickSubmitAvatar}
																					className={'buttonSubmit ' + (!upload_avatar.size ? 'btn-disable' : '')}>
																					Cập nhật
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<p data-v-9792f17c="" onClick={this.onClickChangeAvatar(true)}
													className="mt-3 ml-4 text-center button wbtn btn-large btn-border btn-radius px-3 py-2 color-white bgSecondaryBtn3">
													<i data-v-9792f17c="" className="fas fa-camera mr-2" />
													{t('profile.change_photo')}
												</p>
											</div>
										</div>
										<form data-v-9792f17c="">
											<div className="loading">
												<div className="loading__ring">
													<svg xmlns="http://www.w3.org/2000/svg"
														xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1"
														x="0px" y="0px" viewBox="0 0 100 100"
														style={{ enableBackground: 'new 0 0 100 100' }}
														xmlSpace="preserve"><path d="M85.5,42c-0.2-0.8-0.5-1.7-0.8-2.5c-0.3-0.9-0.7-1.6-1-2.3c-0.3-0.7-0.6-1.3-1-1.9c0.3,0.5,0.5,1.1,0.8,1.7  c0.2,0.7,0.6,1.5,0.8,2.3s0.5,1.7,0.8,2.5c0.8,3.5,1.3,7.5,0.8,12c-0.4,4.3-1.8,9-4.2,13.4c-2.4,4.2-5.9,8.2-10.5,11.2  c-1.1,0.7-2.2,1.5-3.4,2c-0.5,0.2-1.2,0.6-1.8,0.8s-1.3,0.5-1.9,0.8c-2.6,1-5.3,1.7-8.1,1.8l-1.1,0.1L53.8,84c-0.7,0-1.4,0-2.1,0  c-1.4-0.1-2.9-0.1-4.2-0.5c-1.4-0.1-2.8-0.6-4.1-0.8c-1.4-0.5-2.7-0.9-3.9-1.5c-1.2-0.6-2.4-1.2-3.7-1.9c-0.6-0.3-1.2-0.7-1.7-1.1  l-0.8-0.6c-0.3-0.1-0.6-0.4-0.8-0.6l-0.8-0.6L31.3,76l-0.2-0.2L31,75.7l-0.1-0.1l0,0l-1.5-1.5c-1.2-1-1.9-2.1-2.7-3.1  c-0.4-0.4-0.7-1.1-1.1-1.7l-1.1-1.7c-0.3-0.6-0.6-1.2-0.9-1.8c-0.2-0.5-0.6-1.2-0.8-1.8c-0.4-1.2-1-2.4-1.2-3.7  c-0.2-0.6-0.4-1.2-0.5-1.9c-0.1-0.6-0.2-1.2-0.3-1.8c-0.3-1.2-0.3-2.4-0.4-3.7c-0.1-1.2,0-2.5,0.1-3.7c0.2-1.2,0.3-2.4,0.6-3.5  c0.1-0.6,0.3-1.1,0.4-1.7l0.1-0.8l0.3-0.8c1.5-4.3,3.8-8,6.5-11c0.8-0.8,1.4-1.5,2.1-2.1c0.9-0.9,1.4-1.3,2.2-1.8  c1.4-1.2,2.9-2,4.3-2.8c2.8-1.5,5.5-2.3,7.7-2.8s4-0.7,5.2-0.6c0.6-0.1,1.1,0,1.4,0s0.4,0,0.4,0h0.1c2.7,0.1,5-2.2,5-5  c0.1-2.7-2.2-5-5-5c-0.2,0-0.2,0-0.3,0c0,0-0.2,0.1-0.6,0.1c-0.4,0-1,0-1.8,0.1c-1.6,0.1-4,0.4-6.9,1.2c-2.9,0.8-6.4,2-9.9,4.1  c-1.8,1-3.6,2.3-5.4,3.8C26,21.4,25,22.2,24.4,23c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.6,0.7c-0.5,0.4-0.8,0.9-1.3,1.4  c-3.2,3.9-5.9,8.8-7.5,14.3l-0.3,1l-0.2,1.1c-0.1,0.7-0.3,1.4-0.4,2.1c-0.3,1.5-0.4,2.9-0.5,4.5c0,1.5-0.1,3,0.1,4.5  c0.2,1.5,0.2,3,0.6,4.6c0.1,0.7,0.3,1.5,0.4,2.3c0.2,0.8,0.5,1.5,0.7,2.3c0.4,1.6,1.1,3,1.7,4.4c0.3,0.7,0.7,1.4,1.1,2.1  c0.4,0.8,0.8,1.4,1.2,2.1c0.5,0.7,0.9,1.4,1.4,2s0.9,1.3,1.5,1.9c1.1,1.3,2.2,2.7,3.3,3.5l1.7,1.6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0  c0,0,0,0,0,0l0.1,0.1l0.1,0.1h0.2l0.5,0.4l1,0.7c0.4,0.2,0.6,0.5,1,0.7l1.1,0.6c0.8,0.4,1.4,0.9,2.1,1.2c1.4,0.7,2.9,1.5,4.4,2  c1.5,0.7,3.1,1,4.6,1.5c1.5,0.3,3.1,0.7,4.7,0.8c1.6,0.2,3.1,0.2,4.7,0.2c0.8,0,1.6-0.1,2.4-0.1l1.2-0.1l1.1-0.1  c3.1-0.4,6.1-1.3,8.9-2.4c0.8-0.3,1.4-0.6,2.1-0.9s1.3-0.7,2-1.1c1.3-0.7,2.6-1.7,3.7-2.5c0.5-0.4,1-0.9,1.6-1.3l0.8-0.6l0.2-0.2  c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0,0,0,0v0.1l0.1-0.1l0.4-0.4c0.5-0.5,1-1,1.5-1.5c0.3-0.3,0.5-0.5,0.8-0.8l0.7-0.8  c0.9-1.1,1.8-2.2,2.5-3.3c0.4-0.6,0.7-1.1,1.1-1.7c0.3-0.7,0.6-1.2,0.9-1.8c2.4-4.9,3.5-9.8,3.7-14.4C87.3,49.7,86.6,45.5,85.5,42z" /></svg>
												</div>
												<div className="loading__ring">
													<svg xmlns="http://www.w3.org/2000/svg"
														xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1"
														x="0px" y="0px" viewBox="0 0 100 100"
														style={{ enableBackground: 'new 0 0 100 100' }}
														xmlSpace="preserve"><path d="M85.5,42c-0.2-0.8-0.5-1.7-0.8-2.5c-0.3-0.9-0.7-1.6-1-2.3c-0.3-0.7-0.6-1.3-1-1.9c0.3,0.5,0.5,1.1,0.8,1.7  c0.2,0.7,0.6,1.5,0.8,2.3s0.5,1.7,0.8,2.5c0.8,3.5,1.3,7.5,0.8,12c-0.4,4.3-1.8,9-4.2,13.4c-2.4,4.2-5.9,8.2-10.5,11.2  c-1.1,0.7-2.2,1.5-3.4,2c-0.5,0.2-1.2,0.6-1.8,0.8s-1.3,0.5-1.9,0.8c-2.6,1-5.3,1.7-8.1,1.8l-1.1,0.1L53.8,84c-0.7,0-1.4,0-2.1,0  c-1.4-0.1-2.9-0.1-4.2-0.5c-1.4-0.1-2.8-0.6-4.1-0.8c-1.4-0.5-2.7-0.9-3.9-1.5c-1.2-0.6-2.4-1.2-3.7-1.9c-0.6-0.3-1.2-0.7-1.7-1.1  l-0.8-0.6c-0.3-0.1-0.6-0.4-0.8-0.6l-0.8-0.6L31.3,76l-0.2-0.2L31,75.7l-0.1-0.1l0,0l-1.5-1.5c-1.2-1-1.9-2.1-2.7-3.1  c-0.4-0.4-0.7-1.1-1.1-1.7l-1.1-1.7c-0.3-0.6-0.6-1.2-0.9-1.8c-0.2-0.5-0.6-1.2-0.8-1.8c-0.4-1.2-1-2.4-1.2-3.7  c-0.2-0.6-0.4-1.2-0.5-1.9c-0.1-0.6-0.2-1.2-0.3-1.8c-0.3-1.2-0.3-2.4-0.4-3.7c-0.1-1.2,0-2.5,0.1-3.7c0.2-1.2,0.3-2.4,0.6-3.5  c0.1-0.6,0.3-1.1,0.4-1.7l0.1-0.8l0.3-0.8c1.5-4.3,3.8-8,6.5-11c0.8-0.8,1.4-1.5,2.1-2.1c0.9-0.9,1.4-1.3,2.2-1.8  c1.4-1.2,2.9-2,4.3-2.8c2.8-1.5,5.5-2.3,7.7-2.8s4-0.7,5.2-0.6c0.6-0.1,1.1,0,1.4,0s0.4,0,0.4,0h0.1c2.7,0.1,5-2.2,5-5  c0.1-2.7-2.2-5-5-5c-0.2,0-0.2,0-0.3,0c0,0-0.2,0.1-0.6,0.1c-0.4,0-1,0-1.8,0.1c-1.6,0.1-4,0.4-6.9,1.2c-2.9,0.8-6.4,2-9.9,4.1  c-1.8,1-3.6,2.3-5.4,3.8C26,21.4,25,22.2,24.4,23c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.6,0.7c-0.5,0.4-0.8,0.9-1.3,1.4  c-3.2,3.9-5.9,8.8-7.5,14.3l-0.3,1l-0.2,1.1c-0.1,0.7-0.3,1.4-0.4,2.1c-0.3,1.5-0.4,2.9-0.5,4.5c0,1.5-0.1,3,0.1,4.5  c0.2,1.5,0.2,3,0.6,4.6c0.1,0.7,0.3,1.5,0.4,2.3c0.2,0.8,0.5,1.5,0.7,2.3c0.4,1.6,1.1,3,1.7,4.4c0.3,0.7,0.7,1.4,1.1,2.1  c0.4,0.8,0.8,1.4,1.2,2.1c0.5,0.7,0.9,1.4,1.4,2s0.9,1.3,1.5,1.9c1.1,1.3,2.2,2.7,3.3,3.5l1.7,1.6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0  c0,0,0,0,0,0l0.1,0.1l0.1,0.1h0.2l0.5,0.4l1,0.7c0.4,0.2,0.6,0.5,1,0.7l1.1,0.6c0.8,0.4,1.4,0.9,2.1,1.2c1.4,0.7,2.9,1.5,4.4,2  c1.5,0.7,3.1,1,4.6,1.5c1.5,0.3,3.1,0.7,4.7,0.8c1.6,0.2,3.1,0.2,4.7,0.2c0.8,0,1.6-0.1,2.4-0.1l1.2-0.1l1.1-0.1  c3.1-0.4,6.1-1.3,8.9-2.4c0.8-0.3,1.4-0.6,2.1-0.9s1.3-0.7,2-1.1c1.3-0.7,2.6-1.7,3.7-2.5c0.5-0.4,1-0.9,1.6-1.3l0.8-0.6l0.2-0.2  c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0,0,0,0v0.1l0.1-0.1l0.4-0.4c0.5-0.5,1-1,1.5-1.5c0.3-0.3,0.5-0.5,0.8-0.8l0.7-0.8  c0.9-1.1,1.8-2.2,2.5-3.3c0.4-0.6,0.7-1.1,1.1-1.7c0.3-0.7,0.6-1.2,0.9-1.8c2.4-4.9,3.5-9.8,3.7-14.4C87.3,49.7,86.6,45.5,85.5,42z" /></svg>
												</div>
											</div>
											<div data-v-9792f17c="" className="row">
												<div data-v-9792f17c="" className="col-md-6 col-lg-4">
													<div data-v-9792f17c="" className="form-group"><span
														data-v-9792f17c="" className="labelInput">{t('profile.email')}</span>
														<p data-v-9792f17c=""
															className="winput">{email}</p></div>
												</div>
												<div data-v-9792f17c="" className="col-md-6 col-lg-4">
													<div data-v-9792f17c="" className="form-group"><span
														data-v-9792f17c="" className="labelInput">{t('profile.nickname')}</span> <p
															data-v-9792f17c="" className="winput">{username}</p></div>
												</div>
											</div>
											<div data-v-9792f17c="" className="row mb-4">
												<div data-v-9792f17c="" className="col-md-6 col-lg-4">
													<div data-v-9792f17c="" className="form-group mb-0"><span
														data-v-9792f17c="" className="labelInput">{t('profile.first_name')}</span> <input
															data-v-9792f17c="" type="text" onChange={this.onChangeInput('first_name')} value={first_name}
															maxLength="20" className="form-control mb-2 winput color-white" />
													</div>
												</div>
												<div data-v-9792f17c="" className="col-md-6 col-lg-4">
													<div data-v-9792f17c="" className="form-group mb-0"><span
														data-v-9792f17c="" className="labelInput">{t('profile.last_name')}</span> <input
															data-v-9792f17c="" type="text" onChange={this.onChangeInput('last_name')} value={last_name}
															maxLength="20" className="form-control mb-2 winput color-white" />
													</div>
												</div>
											</div>
											<div data-v-9792f17c="" className="col-md-6 col-lg-4  pl-0 mb-4">
												<div data-v-9792f17c="" className="form-group mb-0"><span
													data-v-9792f17c="" className="labelInput">{t('profile.withdrawal_password')}</span> <input
														data-v-9792f17c="" type="password" aria-autocomplete="false"
														autoComplete="off" onChange={this.onChangeInput('withdrawal_password')} value={withdrawal_password} disabled={withdrawal_password_old}
														maxLength="20" className="form-control mb-2 winput color-white" />
												</div>
											</div>
											<div data-v-9792f17c="" className="bottomTools">
												<div data-v-9792f17c="" className="row">
													<div data-v-9792f17c="" className="col-lg-5 col-md-12 offset-md-0">
														<button data-v-9792f17c="" onClick={this.onSubmitInfo} type="button" disabled={!(first_name !== first_name_old || last_name !== last_name_old || withdrawal_password !== withdrawal_password_old)}
															className="button wbtn btn-radius btn-large btn-border color-white btn-secondary">
															{t('profile.update_account')}
														</button>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>

								<div data-v-9792f17c="" className="panel panel--security">
									<div data-v-9792f17c="" className="panel-header"><h3 data-v-9792f17c=""
										className="panel-header-title">{t('profile.verify_account')}</h3></div>
									<div data-v-36ad2db4="" class="panel-body">
										<span className="">{t('profile.status')}: <b style={{ color: is_verify == 1 ? 'green' : 'yellow' }}>{is_verify == 1 ? t('profile.verified') : t('profile.not_verified')}</b>{is_verify == 1 ? <i class="fa fa-check-circle ml-1" style={{ color: is_verify == 1 ? 'green' : 'yellow' }} aria-hidden="true"></i> : <i class="fa fa-exclamation-triangle ml-1" style={{ color: is_verify == 1 ? 'green' : 'yellow' }} aria-hidden="true"></i>}</span>
										<div data-v-36ad2db4="" class="colorWhite block mt-2">
											<div data-v-36ad2db4="" class="row">
												<div data-v-36ad2db4="" class="col-8 col-md-3 font-14 margin-bottom-8 margin-top-8 color-white sub-title">
												{t('profile.identity_verification')}:
												</div>
												<div data-v-36ad2db4="" class="col-md-9 confirm-content">
													<p data-v-36ad2db4="" class="colorSecondary2 font-14 flex-fill">{t('profile.verified_note_1')}<br />{t('profile.verified_note_2')}</p>
													<div data-v-36ad2db4="" class="wrap-button">
														{is_verify === 0 ? <button data-v-36ad2db4=""
															class="btn btn-primary bgSecondaryBtn3"
															onClick={navigateTo('verified').bind(this)}>
															{t('profile.verify_now')}
														</button> : ''}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div data-v-9792f17c="" className="panel panel--security">
									<div data-v-9792f17c="" className="panel-header"><h3 data-v-9792f17c=""
										className="panel-header-title">{t('profile.security')}</h3></div>
									<div data-v-9792f17c="" className="panel-body">
										<div data-v-9792f17c="" className="row mb-5">
											<div data-v-9792f17c="" className="col-md-4 col-xs-12">
												<div data-v-9792f17c="" className="form-group"><span
													data-v-9792f17c="" className="labelInput">{t('profile.current_password')}</span>
													<input
														data-v-9792f17c="" onChange={this.onChangeInput('current_password')}
														value={current_password} type="password"
														className="form-control mb-2 winput color-white" />
												</div>
											</div>
											<div data-v-9792f17c="" className="col-md-4 col-xs-12">
												<div data-v-9792f17c="" className="form-group"><span
													data-v-9792f17c="" className="labelInput">{t('profile.new_password')}</span>
													<input
														data-v-9792f17c="" onChange={this.onChangeInput('new_password')}
														value={new_password} type="password"
														className="form-control mb-2 winput color-white" />
												</div>
											</div>
											<div data-v-9792f17c="" className="col-md-4 col-xs-12">
												<button data-v-9792f17c="" style={{ marginTop: '25px', height: '43px', width: '100%' }} type="button" onClick={this.onSubmitPassword}
													disabled={!(current_password && new_password && new_password.length > 5)}
													className="button wbtn btn-radius btn-large btn-border color-white btn-secondary">{t('profile.update_password')}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div data-v-3bbb76d6="" data-v-9792f17c="" tabIndex="-1" role="dialog" className="modal fade modalEnable show" style={{ display: is_show_modal_auth ? 'block' : 'none' }}>
							<div data-v-3bbb76d6="" className="mask" />
							<div data-v-3bbb76d6="" className="modal-dialog simple modal-sm modal-2fa-custom">
								<form data-v-3bbb76d6="" style={{ border: '1px solid #4b4a79' }}>
									<div data-v-3bbb76d6="" className="modal-content">
										<div className="loading">
											<div className="loading__ring">
												<svg xmlns="http://www.w3.org/2000/svg"
													xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px"
													y="0px" viewBox="0 0 100 100"
													style={{ enableBackground: 'new 0 0 100 100' }} xmlSpace="preserve"><path d="M85.5,42c-0.2-0.8-0.5-1.7-0.8-2.5c-0.3-0.9-0.7-1.6-1-2.3c-0.3-0.7-0.6-1.3-1-1.9c0.3,0.5,0.5,1.1,0.8,1.7  c0.2,0.7,0.6,1.5,0.8,2.3s0.5,1.7,0.8,2.5c0.8,3.5,1.3,7.5,0.8,12c-0.4,4.3-1.8,9-4.2,13.4c-2.4,4.2-5.9,8.2-10.5,11.2  c-1.1,0.7-2.2,1.5-3.4,2c-0.5,0.2-1.2,0.6-1.8,0.8s-1.3,0.5-1.9,0.8c-2.6,1-5.3,1.7-8.1,1.8l-1.1,0.1L53.8,84c-0.7,0-1.4,0-2.1,0  c-1.4-0.1-2.9-0.1-4.2-0.5c-1.4-0.1-2.8-0.6-4.1-0.8c-1.4-0.5-2.7-0.9-3.9-1.5c-1.2-0.6-2.4-1.2-3.7-1.9c-0.6-0.3-1.2-0.7-1.7-1.1  l-0.8-0.6c-0.3-0.1-0.6-0.4-0.8-0.6l-0.8-0.6L31.3,76l-0.2-0.2L31,75.7l-0.1-0.1l0,0l-1.5-1.5c-1.2-1-1.9-2.1-2.7-3.1  c-0.4-0.4-0.7-1.1-1.1-1.7l-1.1-1.7c-0.3-0.6-0.6-1.2-0.9-1.8c-0.2-0.5-0.6-1.2-0.8-1.8c-0.4-1.2-1-2.4-1.2-3.7  c-0.2-0.6-0.4-1.2-0.5-1.9c-0.1-0.6-0.2-1.2-0.3-1.8c-0.3-1.2-0.3-2.4-0.4-3.7c-0.1-1.2,0-2.5,0.1-3.7c0.2-1.2,0.3-2.4,0.6-3.5  c0.1-0.6,0.3-1.1,0.4-1.7l0.1-0.8l0.3-0.8c1.5-4.3,3.8-8,6.5-11c0.8-0.8,1.4-1.5,2.1-2.1c0.9-0.9,1.4-1.3,2.2-1.8  c1.4-1.2,2.9-2,4.3-2.8c2.8-1.5,5.5-2.3,7.7-2.8s4-0.7,5.2-0.6c0.6-0.1,1.1,0,1.4,0s0.4,0,0.4,0h0.1c2.7,0.1,5-2.2,5-5  c0.1-2.7-2.2-5-5-5c-0.2,0-0.2,0-0.3,0c0,0-0.2,0.1-0.6,0.1c-0.4,0-1,0-1.8,0.1c-1.6,0.1-4,0.4-6.9,1.2c-2.9,0.8-6.4,2-9.9,4.1  c-1.8,1-3.6,2.3-5.4,3.8C26,21.4,25,22.2,24.4,23c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.6,0.7c-0.5,0.4-0.8,0.9-1.3,1.4  c-3.2,3.9-5.9,8.8-7.5,14.3l-0.3,1l-0.2,1.1c-0.1,0.7-0.3,1.4-0.4,2.1c-0.3,1.5-0.4,2.9-0.5,4.5c0,1.5-0.1,3,0.1,4.5  c0.2,1.5,0.2,3,0.6,4.6c0.1,0.7,0.3,1.5,0.4,2.3c0.2,0.8,0.5,1.5,0.7,2.3c0.4,1.6,1.1,3,1.7,4.4c0.3,0.7,0.7,1.4,1.1,2.1  c0.4,0.8,0.8,1.4,1.2,2.1c0.5,0.7,0.9,1.4,1.4,2s0.9,1.3,1.5,1.9c1.1,1.3,2.2,2.7,3.3,3.5l1.7,1.6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0  c0,0,0,0,0,0l0.1,0.1l0.1,0.1h0.2l0.5,0.4l1,0.7c0.4,0.2,0.6,0.5,1,0.7l1.1,0.6c0.8,0.4,1.4,0.9,2.1,1.2c1.4,0.7,2.9,1.5,4.4,2  c1.5,0.7,3.1,1,4.6,1.5c1.5,0.3,3.1,0.7,4.7,0.8c1.6,0.2,3.1,0.2,4.7,0.2c0.8,0,1.6-0.1,2.4-0.1l1.2-0.1l1.1-0.1  c3.1-0.4,6.1-1.3,8.9-2.4c0.8-0.3,1.4-0.6,2.1-0.9s1.3-0.7,2-1.1c1.3-0.7,2.6-1.7,3.7-2.5c0.5-0.4,1-0.9,1.6-1.3l0.8-0.6l0.2-0.2  c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0,0,0,0v0.1l0.1-0.1l0.4-0.4c0.5-0.5,1-1,1.5-1.5c0.3-0.3,0.5-0.5,0.8-0.8l0.7-0.8  c0.9-1.1,1.8-2.2,2.5-3.3c0.4-0.6,0.7-1.1,1.1-1.7c0.3-0.7,0.6-1.2,0.9-1.8c2.4-4.9,3.5-9.8,3.7-14.4C87.3,49.7,86.6,45.5,85.5,42z" /></svg>
											</div>
											<div className="loading__ring">
												<svg xmlns="http://www.w3.org/2000/svg"
													xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px"
													y="0px" viewBox="0 0 100 100"
													style={{ enableBackground: 'new 0 0 100 100' }} xmlSpace="preserve"><path d="M85.5,42c-0.2-0.8-0.5-1.7-0.8-2.5c-0.3-0.9-0.7-1.6-1-2.3c-0.3-0.7-0.6-1.3-1-1.9c0.3,0.5,0.5,1.1,0.8,1.7  c0.2,0.7,0.6,1.5,0.8,2.3s0.5,1.7,0.8,2.5c0.8,3.5,1.3,7.5,0.8,12c-0.4,4.3-1.8,9-4.2,13.4c-2.4,4.2-5.9,8.2-10.5,11.2  c-1.1,0.7-2.2,1.5-3.4,2c-0.5,0.2-1.2,0.6-1.8,0.8s-1.3,0.5-1.9,0.8c-2.6,1-5.3,1.7-8.1,1.8l-1.1,0.1L53.8,84c-0.7,0-1.4,0-2.1,0  c-1.4-0.1-2.9-0.1-4.2-0.5c-1.4-0.1-2.8-0.6-4.1-0.8c-1.4-0.5-2.7-0.9-3.9-1.5c-1.2-0.6-2.4-1.2-3.7-1.9c-0.6-0.3-1.2-0.7-1.7-1.1  l-0.8-0.6c-0.3-0.1-0.6-0.4-0.8-0.6l-0.8-0.6L31.3,76l-0.2-0.2L31,75.7l-0.1-0.1l0,0l-1.5-1.5c-1.2-1-1.9-2.1-2.7-3.1  c-0.4-0.4-0.7-1.1-1.1-1.7l-1.1-1.7c-0.3-0.6-0.6-1.2-0.9-1.8c-0.2-0.5-0.6-1.2-0.8-1.8c-0.4-1.2-1-2.4-1.2-3.7  c-0.2-0.6-0.4-1.2-0.5-1.9c-0.1-0.6-0.2-1.2-0.3-1.8c-0.3-1.2-0.3-2.4-0.4-3.7c-0.1-1.2,0-2.5,0.1-3.7c0.2-1.2,0.3-2.4,0.6-3.5  c0.1-0.6,0.3-1.1,0.4-1.7l0.1-0.8l0.3-0.8c1.5-4.3,3.8-8,6.5-11c0.8-0.8,1.4-1.5,2.1-2.1c0.9-0.9,1.4-1.3,2.2-1.8  c1.4-1.2,2.9-2,4.3-2.8c2.8-1.5,5.5-2.3,7.7-2.8s4-0.7,5.2-0.6c0.6-0.1,1.1,0,1.4,0s0.4,0,0.4,0h0.1c2.7,0.1,5-2.2,5-5  c0.1-2.7-2.2-5-5-5c-0.2,0-0.2,0-0.3,0c0,0-0.2,0.1-0.6,0.1c-0.4,0-1,0-1.8,0.1c-1.6,0.1-4,0.4-6.9,1.2c-2.9,0.8-6.4,2-9.9,4.1  c-1.8,1-3.6,2.3-5.4,3.8C26,21.4,25,22.2,24.4,23c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.6,0.7c-0.5,0.4-0.8,0.9-1.3,1.4  c-3.2,3.9-5.9,8.8-7.5,14.3l-0.3,1l-0.2,1.1c-0.1,0.7-0.3,1.4-0.4,2.1c-0.3,1.5-0.4,2.9-0.5,4.5c0,1.5-0.1,3,0.1,4.5  c0.2,1.5,0.2,3,0.6,4.6c0.1,0.7,0.3,1.5,0.4,2.3c0.2,0.8,0.5,1.5,0.7,2.3c0.4,1.6,1.1,3,1.7,4.4c0.3,0.7,0.7,1.4,1.1,2.1  c0.4,0.8,0.8,1.4,1.2,2.1c0.5,0.7,0.9,1.4,1.4,2s0.9,1.3,1.5,1.9c1.1,1.3,2.2,2.7,3.3,3.5l1.7,1.6c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0  c0,0,0,0,0,0l0.1,0.1l0.1,0.1h0.2l0.5,0.4l1,0.7c0.4,0.2,0.6,0.5,1,0.7l1.1,0.6c0.8,0.4,1.4,0.9,2.1,1.2c1.4,0.7,2.9,1.5,4.4,2  c1.5,0.7,3.1,1,4.6,1.5c1.5,0.3,3.1,0.7,4.7,0.8c1.6,0.2,3.1,0.2,4.7,0.2c0.8,0,1.6-0.1,2.4-0.1l1.2-0.1l1.1-0.1  c3.1-0.4,6.1-1.3,8.9-2.4c0.8-0.3,1.4-0.6,2.1-0.9s1.3-0.7,2-1.1c1.3-0.7,2.6-1.7,3.7-2.5c0.5-0.4,1-0.9,1.6-1.3l0.8-0.6l0.2-0.2  c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0,0,0,0v0.1l0.1-0.1l0.4-0.4c0.5-0.5,1-1,1.5-1.5c0.3-0.3,0.5-0.5,0.8-0.8l0.7-0.8  c0.9-1.1,1.8-2.2,2.5-3.3c0.4-0.6,0.7-1.1,1.1-1.7c0.3-0.7,0.6-1.2,0.9-1.8c2.4-4.9,3.5-9.8,3.7-14.4C87.3,49.7,86.6,45.5,85.5,42z" /></svg>
											</div>
										</div>
										<button data-v-3bbb76d6="" type="button" onClick={this.onShowAuthModal(false)} aria-label="Close" className="close">
											<img data-v-3bbb76d6=""
												src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgICA8ZyBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNmZmZmZmYiIHN0cm9rZT0iI2ZmZmZmZiIgY2xhc3M9Im5jLWljb24td3JhcHBlciI+CiAgICAgICAgPGcgY2xhc3M9Im5jLWludGVyYWN0X21lbnUtY2xvc2UtMi1vLTMyIj4KICAgICAgICAgICAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yIDZoMjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTAuMDApIHJvdGF0ZSg0NS4wMCAxNiA2KSIgLz4KICAgICAgICAgICAgPHBhdGggZGF0YS1jb2xvcj0iY29sb3ItMiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMiAxNmgyOCIgb3BhY2l0eT0iMCIgLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yIDI2aDI4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0xMCkgcm90YXRlKC00NSAxNiAyNikiIC8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="
												alt="" /></button>
										<div data-v-3bbb76d6="" className="modal-body">
											<div data-v-3bbb76d6="" className="subtitle mb-2"><h3 data-v-3bbb76d6=""
												className="color-white font-weight-bold text-center mb-0">Xác
												Thực Google</h3></div>
											<div data-v-3bbb76d6="" className="row mb-5 mb-sm-4">
												<div data-v-3bbb76d6="" className="col-12 text-center"><p
													data-v-3bbb76d6="" className="desc mb-0"><small data-v-3bbb76d6=""
														className="description"><span
															data-v-3bbb76d6="" className="noted colorRed">
															Mở ứng dụng Google Authenticator của bạn và quét mã QR bên dưới hoặc nhập khóa vào ứng dụng. Khóa này dùng để khôi phục Xác thực Google của bạn khi bạn đổi hoặc mất điện thoại. Vui lòng sao lưu khóa này trước khi kích hoạt Xác thực Google.
														</span></small></p></div>
											</div>
											<div data-v-3bbb76d6="" className="boxContent g_auth">
												<div data-v-3bbb76d6="" className="row h-100">
													<div data-v-3bbb76d6="" className="col-12 d-flex flex-column">
														<div data-v-3bbb76d6=""
															className="text-center qr-code-wrap mb-5 mb-sm-4">
															<div data-v-3de7c115="" data-v-3bbb76d6="" style={{ width: '150px', height: '150px' }} className="qr-code-container qr-200 mx-auto">
																<div dangerouslySetInnerHTML={{ __html: qr_code }} />
															</div>
														</div>
														<div data-v-3bbb76d6="" className="row backupkey">
															<div data-v-3bbb76d6=""
																className="col-md-3 label color-white-50">Mã sao lưu:
															</div>
															<div data-v-3bbb76d6=""
																className="col-md-9 key pl-0 pr-lg-3 pr-0">
																<div data-v-3bbb76d6="" className="grouplabel">
																	<div data-v-3bbb76d6=""
																		className="input-group transparent"><input
																			data-v-3bbb76d6="" type="text"
																			readOnly="readonly"
																			value={secret}
																			className="form-control pl-3 pl-sm-0" />
																		<div data-v-3bbb76d6="" className="input-group-append"><a
																			data-v-3bbb76d6="" href="#"
																			onClick={this.onCopySecret}
																			className="input-group-addon">
																			<svg data-v-3bbb76d6=""
																				xmlns="http://www.w3.org/2000/svg"
																				viewBox="0 0 14 16">
																				<g data-v-3bbb76d6=""
																					id="single-copy-04"
																					transform="translate(-2)">
																					<g data-v-3bbb76d6="" id="Group_190"
																						data-name="Group 190">
																						<rect data-v-3bbb76d6=""
																							id="Rectangle_502"
																							data-name="Rectangle 502"
																							width="10" height="12"
																							transform="translate(2.5 3.5)"
																							className="icon-copy" />
																						<path data-v-3bbb76d6=""
																							id="Path_90"
																							data-name="Path 90"
																							d="M4.5.5h11v13"
																							className="icon-copy" />
																						<line data-v-3bbb76d6=""
																							id="Line_187"
																							data-name="Line 187"
																							x2="4"
																							transform="translate(5.5 6.5)"
																							className="icon-copy" />
																						<line data-v-3bbb76d6=""
																							id="Line_188"
																							data-name="Line 188"
																							x2="4"
																							transform="translate(5.5 9.5)"
																							className="icon-copy" />
																						<line data-v-3bbb76d6=""
																							id="Line_189"
																							data-name="Line 189"
																							x2="4"
																							transform="translate(5.5 12.5)"
																							className="icon-copy" />
																					</g>
																				</g>
																			</svg>
																		</a>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div data-v-3bbb76d6="" className="form-group"><label
															data-v-3bbb76d6="" className="color-white-50">Mật
															khẩu</label> <input data-v-3bbb76d6="" type="password"
																value={auth_password}
																onChange={this.onChangeInput('auth_password')}
																className="form-control" /></div>
														<div data-v-3bbb76d6=""
															className="form-group verification-code"><label
																data-v-3bbb76d6="" className="color-white-50">Mã Xác nhận
																Email</label>
															<div data-v-3bbb76d6="" className="input-group mb-3">
																<div data-v-3bbb76d6="" className="position-relative">
																	<input data-v-3bbb76d6="" type="text"
																		placeholder="Mã Xác nhận"
																		value={auth_email_code}
																		onChange={this.onChangeInput('auth_email_code')}
																		className="form-control" /> <span
																			data-v-3bbb76d6=""
																			onClick={this.onClickPaste('auth_email_code')}
																			className="paste">Paste</span></div>
																<button data-v-3bbb76d6="" type="button"
																	onClick={this.onSendOTPEmail}
																	className="btn btn-primary">
																	Gửi Mã
																</button>
															</div>
														</div>
														<div data-v-3bbb76d6="" className="form-group"><label
															data-v-3bbb76d6="" className="color-white-50">Mã 2FA</label>
															<div data-v-3bbb76d6="" className="position-relative"><input
																data-v-3bbb76d6="" type="number"
																value={auth_two_fa_code}
																onChange={this.onChangeInput('auth_two_fa_code')}
																className="form-control" /> <span data-v-3bbb76d6="" onClick={this.onClickPaste('auth_two_fa_code')}
																	className="paste">Paste</span>
															</div>
														</div>
														<div data-v-3bbb76d6="" className="listTools mt-auto">
															<div data-v-3bbb76d6="" className="row">
																<div data-v-3bbb76d6=""
																	className="col-md-6 offset-md-3">
																	<button data-v-3bbb76d6="" disabled={!is_button_enable} type="button" onClick={this.onEnableTwoFa} className="btn btn-primary btn-lg btn-block">Bật</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>

						<div data-v-3bbb76d6="" data-v-9792f17c="" tabIndex="-1" role="dialog" className="modal fade modalEnable show" style={{ display: is_show_modal_disable_two_fa ? 'block' : 'none' }}>
							<div data-v-3bbb76d6="" className="mask" />
							<div data-v-3bbb76d6="" className="modal-dialog simple modal-sm modal-2fa-custom">
								<form data-v-3bbb76d6="" style={{ border: '1px solid #4b4a79' }}>
									<div data-v-3bbb76d6="" className="modal-content">
										<button data-v-3bbb76d6="" type="button" onClick={this.onShowDisableTwoFa(false)} aria-label="Close" className="close">
											<img data-v-3bbb76d6=""
												src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+CiAgICA8ZyBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiBzdHJva2UtbGluZWpvaW49Im1pdGVyIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9IiNmZmZmZmYiIHN0cm9rZT0iI2ZmZmZmZiIgY2xhc3M9Im5jLWljb24td3JhcHBlciI+CiAgICAgICAgPGcgY2xhc3M9Im5jLWludGVyYWN0X21lbnUtY2xvc2UtMi1vLTMyIj4KICAgICAgICAgICAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yIDZoMjgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTAuMDApIHJvdGF0ZSg0NS4wMCAxNiA2KSIgLz4KICAgICAgICAgICAgPHBhdGggZGF0YS1jb2xvcj0iY29sb3ItMiIgZmlsbD0ibm9uZSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMiAxNmgyOCIgb3BhY2l0eT0iMCIgLz4KICAgICAgICAgICAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0yIDI2aDI4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0xMCkgcm90YXRlKC00NSAxNiAyNikiIC8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="
												alt="" /></button>
										<div data-v-3bbb76d6="" className="modal-body">
											<div data-v-3bbb76d6="" className="subtitle mb-2"><h3 data-v-3bbb76d6=""
												className="color-white font-weight-bold text-center mb-0">Tắt Xác
												Thực Google</h3></div>
											<div data-v-3bbb76d6="" className="boxContent g_auth">
												<div data-v-3bbb76d6="" className="row h-100">
													<div data-v-3bbb76d6="" className="col-12 d-flex flex-column">
														<div data-v-3bbb76d6="" className="form-group"><label
															data-v-3bbb76d6="" className="color-white-50">Mật
															khẩu</label> <input data-v-3bbb76d6="" type="password"
																value={auth_password}
																onChange={this.onChangeInput('auth_password')}
																className="form-control" /></div>
														<div data-v-3bbb76d6=""
															className="form-group verification-code"><label
																data-v-3bbb76d6="" className="color-white-50">Mã Xác nhận Email</label>
															<div data-v-3bbb76d6="" className="input-group mb-3">
																<div data-v-3bbb76d6="" className="position-relative">
																	<input data-v-3bbb76d6="" type="text"
																		placeholder="Mã Xác nhận"
																		value={auth_email_code}
																		onChange={this.onChangeInput('auth_email_code')}
																		className="form-control" /> <span
																			data-v-3bbb76d6=""
																			onClick={this.onClickPaste('auth_email_code')}
																			className="paste">Paste</span></div>
																<button data-v-3bbb76d6="" type="button"
																	onClick={this.onSendOTPEmail}
																	className="btn btn-primary">
																	Gửi Mã
																</button>
															</div>
														</div>
														<div data-v-3bbb76d6="" className="form-group"><label
															data-v-3bbb76d6="" className="color-white-50">Mã 2FA</label>
															<div data-v-3bbb76d6="" className="position-relative"><input
																data-v-3bbb76d6="" type="number"
																value={auth_two_fa_code}
																onChange={this.onChangeInput('auth_two_fa_code')}
																className="form-control" /> <span data-v-3bbb76d6="" onClick={this.onClickPaste('auth_two_fa_code')}
																	className="paste">Paste</span>
															</div>
														</div>
														<div data-v-3bbb76d6="" className="listTools mt-auto">
															<div data-v-3bbb76d6="" className="row">
																<div data-v-3bbb76d6=""
																	className="col-md-6 offset-md-3">
																	<button data-v-3bbb76d6="" disabled={!is_button_enable} type="button" onClick={this.onDisableTwoFa} className="btn btn-primary btn-lg btn-block">Bật</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div >
		);
	}
}

function mapStateToProps(state) {
	return {
		memberReducer: state.memberReducer,
		appReducer: state.appReducer
	};
}

export default connect(mapStateToProps, {
	fetchingUser,
	fetchingUserSuccess
})(withTranslation()(withRouter(Profile)));

